import React, { useEffect, useState } from "react";
import {
  Card,
  CircularProgress,
  Grid,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useTranslation } from 'react-i18next';
import EventIcon from '@mui/icons-material/Event';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import ListAltIcon from '@mui/icons-material/ListAlt';
import BiotechIcon from '@mui/icons-material/Biotech';
import { SimpleIconTextButton } from "../../Common/DashboardIcons";
import { AVANGARD_WEB_URL, REACT_APP_PORTAL_API_URL } from "../../../../KeyVariables";
import { useNavigate } from "react-router-dom";
import { ShoppingCartClient } from "../../../../api/ShoppingCart/ShoppingCartClient";
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';

export const PatientIcons = () => {
  const { t } = useTranslation("Portal");
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const lngCode = i18n.language.slice(0, 2);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); 
  const shoppingCartClient = new ShoppingCartClient(REACT_APP_PORTAL_API_URL);
  
  const [loading, setLoading] = useState(false);
  const [shoppingCartItemsCount, setShoppingCartItemsCount] = useState(0);
  const [cartIdentity, setCartIdentity] = useState("");

  useEffect(() => {
    const fetch = async () => {
      try {
        setLoading(true);
        const response = await shoppingCartClient.getlatestcart();
        if(response){
          try {
            const items = await shoppingCartClient.shoppingcartitemsbyidentitycount(response)
          setShoppingCartItemsCount(items)
          } catch (ex) {
            console.error(ex);
          } 
        }
        setCartIdentity(response);
      } catch (ex) {
        console.error(ex);
      } finally {
        setLoading(false);
      }
    };
    fetch();
  }, []);

  return (
    <Grid item xs={12}>
      <Card
        sx={{
          position: "relative",
          p: 1,
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: isMobile ? 0 : 2, 
          justifyContent: isMobile ? "space-between" : 'inherit',
          flexWrap: "wrap",
        }}
      >
        <SimpleIconTextButton
          key={"scheduler"}
          icon={EventIcon}
          text={t('Portal_Schedule')}
          onClick={() => navigate("/calendar")}
        />

        <SimpleIconTextButton
          key={"pricelist"}
          icon={ListAltIcon}
          text={t('Portal_PriceList')}
          onClick={() => window.open(`${AVANGARD_WEB_URL}/${lngCode}/analysis`, "_self")}
        />

        <SimpleIconTextButton
          key={"lab"}
          icon={BiotechIcon}
          text={t('Portal_Laboratory')}
          onClick={() => window.open(`${AVANGARD_WEB_URL}/${lngCode}/laboratory`, "_self")}
        />

        <SimpleIconTextButton
          key={"lab"}
          icon={ReceiptLongIcon}
          text={t('Portal_Carts')}
          onClick={() => window.open('/patient-archive?Tab=shoppingcarts', '_self')}
        />
      
        {(cartIdentity && !loading) && (
          <SimpleIconTextButton
            badgeContent={shoppingCartItemsCount}
            key={"shoppingcart"}
            icon={loading ? CircularProgress : ShoppingCartIcon}
            text={t('Portal_Cart')}
            onClick={() => navigate(`/shoppingcart/${cartIdentity}`)}
          />
        )}
      </Card>

    </Grid>
  );
};
